import { useState } from "react";
import { COUNTRIES } from "../../../../helpers";
import { CountrySelector } from "../../../common/select/country-select";
import { useForm } from "../../context/waitlist-context";
import {
  CustomDateInput,
  CustomDropdown,
  CustomInput,
} from "./input-component";

const ResidenceType = [
  { label: "Rented", value: "rented" },
  { label: "Self-Owned", value: "self_owned" },
];

const GENDER = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];

export function PersonalDetails() {
  const { formData, updateFormData, nextStep } = useForm();
  const { personalDetails } = formData;

  const [selectedCountry, setSelectedCountry] = useState(
    COUNTRIES.find((country) => {
      return country.code === "91";
    }) || COUNTRIES[104],
  );
  const [phoneNumber, setPhoneNumber] = useState("");

  const [countrySelectorOpen, setCountrySelectorOpen] = useState(false);

  const handleCountryChange = (selectedValue: {
    value: string;
    code: string;
  }) => {
    const selected = COUNTRIES.find(
      (country) => country.value === selectedValue.value,
    );
    if (selected) setSelectedCountry(selected);
    setCountrySelectorOpen(false);
  };

  // const {mutateAsync: updateUser} = useUpdateUserMutation()

  const handleSubmit = async (e: any) => {
    try {
      e.preventDefault();
      // const userData = {
      //   first_name: personalDetails.firstName,
      //   last_name: personalDetails.lastName,
      //   email: personalDetails.email,
      //   dob: personalDetails.dateOfBirth,
      //   designation: personalDetails.designation,
      //   industry: personalDetails.industry,
      //   location: { consent : personalDetails.location },
      // }
      // await updateUser(userData)
      nextStep();
    } catch (error) {
      console.error("Error in updating user", error);
    }
  };

  const handleChange = (field: string, value: string) => {
    updateFormData("personalDetails", {
      ...personalDetails,
      [field]: value,
    });
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-4 flex flex-col justify-between h-full overflow-scroll"
    >
      <div className="space-y-4 flex-1 overflow-scroll">
        <div className="grid sm:grid-cols-2 gap-4">
          <CustomInput
            placeholder="First Name"
            value={personalDetails.firstName}
            onChange={(name, value) => handleChange(name, value)}
            name="firstName"
          />
          <CustomInput
            placeholder="Last Name"
            value={personalDetails.lastName}
            onChange={(name, value) => handleChange(name, value)}
            name="lastName"
          />
        </div>
        <div className="flex items-center border rounded px-3 w-full h-14">
          <CountrySelector
            id="country-selector"
            open={countrySelectorOpen}
            onToggle={() => setCountrySelectorOpen(!countrySelectorOpen)}
            onChange={handleCountryChange}
            selectedValue={selectedCountry}
            customClass=" !text-black bg-white"
          />

          <div className="h-6 w-[1px] bg-gray-300 mx-3" />
          <input
            type="tel"
            name="mobile"
            onChange={(e) => {
              setPhoneNumber(e.target.value);
              handleChange(
                "phoneNumber",
                selectedCountry.code + e.target.value,
              );
            }}
            pattern="[0-9]{6,16}"
            maxLength={16}
            minLength={6}
            placeholder="Phone Number"
            value={
              phoneNumber ? phoneNumber : personalDetails.phoneNumber.slice(2)
            }
            required
            className="flex-1 pl-5 focus:outline-none  outline-none border-none left-4 w-full"
          />
        </div>
        <CustomInput
          placeholder="Email ID"
          value={personalDetails.email}
          onChange={(name, value) => handleChange(name, value)}
          name="email"
        />
        <div className="grid sm:grid-cols-2 gap-4">
          <CustomDropdown
            placeholder="Gender"
            value={personalDetails.gender}
            onChange={(name, value) => handleChange(name, value)}
            name="gender"
            options={GENDER}
          />
          <CustomDateInput
            placeholder="Date of Birth"
            value={personalDetails.dateOfBirth}
            onChange={(name, value) => handleChange(name, value)}
            name="dateOfBirth"
            max={
              new Date(new Date().setFullYear(new Date().getFullYear() - 4))
                .toISOString()
                .split("T")[0]
            }
          />
        </div>
        <CustomInput
          placeholder="PAN Number"
          value={personalDetails.panCard}
          onChange={(name, value) => handleChange(name, value)}
          name="panCard"
          regexPattern={/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/}
          errorMessage="Invalid PAN Number"
        />
        <CustomDropdown
          placeholder="Residence Type"
          value={personalDetails.residenceType}
          onChange={(name, value) => handleChange(name, value)}
          name="residenceType"
          options={ResidenceType}
        />
        <CustomInput
          placeholder="Pincode"
          value={personalDetails.pincode}
          onChange={(name, value) => handleChange(name, value)}
          name="pincode"
        />
        <div className="grid sm:grid-cols-2 gap-4">
          <CustomInput
            placeholder="City"
            value={personalDetails.city}
            onChange={(name, value) => handleChange(name, value)}
            name="city"
          />
          <CustomInput
            placeholder="State"
            value={personalDetails.state}
            onChange={(name, value) => handleChange(name, value)}
            name="state"
          />
        </div>
      </div>
      <div className="h-fit">
        <hr className="border-t border-gray-300" />
        <div className="flex justify-end pt-2">
          <button
            type="submit"
            className="px-4 py-2 rounded-md text-sm font-medium text-white animate-light bg-[#007aff]"
          >
            Continue
          </button>
        </div>
      </div>
    </form>
  );
}
